import { VIREMENT, LETTRE_CHEQUE } from '@/configuration/parametrage/modeReglementConf';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';

export const LOT_PAIEMENT_EXPORT = 'lotpaiement';

export const ACTION_EDIT_REFERENCE_REGLEMENT = 'editionReferenceReglement';
export const ACTION_DELETE_PAIEMENT = 'suppressionPaiement';
export const ACTION_GENERATION_ECRITURE = 'generationEcriture';

export const TYPE_EDITION_LOT_PAIEMENT_CHEQUE_MANUEL = 'LotPaiementChequeManuel';
export const TYPE_EDITION_LOT_PAIEMENT_LETTRE_CHEQUE = 'LotPaiementLettreCheque';
export const TYPE_EDITION_LOT_PAIEMENT_VIREMENT = 'LotPaiementVirement';
export const TYPE_EDITION_LOT_PAIEMENT_BAUX = 'LotPaiementBaux';
export const EDITION_REGROUPEMENT_PAR_FACE = 'RegrouperParFace';
export const EDITION_REGROUPEMENT_PAR_DISPOSITIF = 'RegrouperParDispositif';

export const LISTE_CHOICE_EDITION_LOT_PAIEMENT = [
  {
    actionAchat: [LETTRE_CHEQUE],
    typeEdition: EDITION_REGROUPEMENT_PAR_FACE,
    libelle: 'detailLotPaiement.edition.lettreChequeFace',
    typeDonnee: TYPE_EDITION_LOT_PAIEMENT_LETTRE_CHEQUE,
    extentions: [TYPE_PDF],
    extra: {
      type: 'number',
      param: 'NumeroCheque',
      libelle: 'detailLotPaiement.edition.numero1cheque',
      obligatoire: true,
    },
  },
  {
    actionAchat: [LETTRE_CHEQUE],
    typeEdition: EDITION_REGROUPEMENT_PAR_DISPOSITIF,
    libelle: 'detailLotPaiement.edition.lettreChequeDispositif',
    typeDonnee: TYPE_EDITION_LOT_PAIEMENT_LETTRE_CHEQUE,
    extentions: [TYPE_PDF],
    extra: {
      type: 'number',
      param: 'NumeroCheque',
      libelle: 'detailLotPaiement.edition.numero1cheque',
      obligatoire: true,
    },
  },
  {
    actionAchat: [LETTRE_CHEQUE], typeEdition: EDITION_REGROUPEMENT_PAR_FACE, libelle: 'detailLotPaiement.edition.chequeManuelFace', typeDonnee: TYPE_EDITION_LOT_PAIEMENT_CHEQUE_MANUEL,
  },
  {
    actionAchat: [LETTRE_CHEQUE], typeEdition: EDITION_REGROUPEMENT_PAR_DISPOSITIF, libelle: 'detailLotPaiement.edition.chequeManuelDispositif', typeDonnee: TYPE_EDITION_LOT_PAIEMENT_CHEQUE_MANUEL,
  },
  {
    actionAchat: [VIREMENT], typeEdition: EDITION_REGROUPEMENT_PAR_FACE, libelle: 'detailLotPaiement.edition.VirementFace', typeDonnee: TYPE_EDITION_LOT_PAIEMENT_VIREMENT,
  },
  {
    actionAchat: [VIREMENT], typeEdition: EDITION_REGROUPEMENT_PAR_DISPOSITIF, libelle: 'detailLotPaiement.edition.VirementDispositif', typeDonnee: TYPE_EDITION_LOT_PAIEMENT_VIREMENT,
  },
  {
    actionAchat: [LETTRE_CHEQUE, VIREMENT],
    typeEdition: '',
    libelle: 'detailLotPaiement.edition.lotPaiementBaux',
    typeDonnee: TYPE_EDITION_LOT_PAIEMENT_BAUX,
    extentions: [TYPE_PDF, TYPE_DOCX],
  },
];
